import { put, call, takeLatest } from "redux-saga/effects";
import axios from "axios";

import { GET_USER_REQUEST, getUserSuccess, getUserError } from "./actions";

import { logoutRequest } from "../login/actions";
import { Env } from "../../env";

function* getUserRequest(action) {
  const { id: accessToken, userId } = action;
  let response;
  let response1;

  try {
    response = yield call(axios.get, `${Env.BASE_API_URL}/Accounts/${userId}`, {
      headers: { Authorization: accessToken },
    });
  } catch (err) {
    if (err.response && err.response.status === 401) {
      yield put(logoutRequest());
    } else {
      yield put(getUserError("Somthing is wrong."));
    }
    return;
  }
  try {
    response1 = yield call(axios.get, `${Env.BASE_API_URL}/Accounts/status`, {
      headers: { Authorization: accessToken },
    });
    console.log("Response isSubscribed ", response1);
  } catch (err) {
    if (err.response && err.response.status === 401) {
      yield put(logoutRequest());
    }
    return;
  }
  //  saveAdminData(response1.data);
  yield put(getUserSuccess(response.data, response1.data));
}

export default function* watchGetUserRequest() {
  yield takeLatest(GET_USER_REQUEST, getUserRequest);
}



// WEBPACK FOOTER //
// ./src/pages/admin/saga.js